import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useQuery } from '@apollo/client';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Stars from '@material-ui/icons/Stars';
import RadioGroupField from './radio-group-field';
import Tag from '../tag';
import { useAppContext } from '../../contexts/app';
import { myGroupsQuery } from '../../apollo/groups';
import HostGroup from '../host-group';
import Host from '../host';

const useStyles = makeStyles((theme) => ({
  tag: {
    marginLeft: theme.spacing(1),
  },
}));

const HostField = ({ disabled, user: userOverride, group: groupOverride, ...rest }) => {
  const { loggedInUser, isLoggedIn } = useAppContext();
  const {
    values: { groupId },
  } = useFormikContext();
  const classes = useStyles();

  const {
    data: groupsData,
    loading: groupLoading,
  } = useQuery(myGroupsQuery, {
    skip: !isLoggedIn,
  });

  const group = useMemo(() => {
    if (!groupId) {
      return null;
    }
    if (groupOverride && groupId === groupOverride.id) {
      return groupOverride;
    }
    if (!groupsData) {
      return null;
    }
    return _find(_get(groupsData, 'me.groups', []), (g) => g.id === groupId);
  }, [groupsData, groupId, groupOverride]);

  const user = userOverride || loggedInUser;

  const options = useMemo(() => {
    return [
      {
        value: 'User',
        label: user ?
          <Host
            event={{
              hostType: 'User',
              user: user,
              group,
            }}
            simple
            target="_blank"
          /> :
          'You',
      },
      ...(group && group.permissions.editable ? [{
        value: 'Group',
        label: (
          <Fragment>
            <HostGroup
              group={group}
              simple
              target="_blank"
            />
            <Tag color="primary" className={classes.tag}>
              <Stars />
              Group Hosted
            </Tag>
          </Fragment>
        ),
      }] : []),
    ];
  }, [user, group]);

  return (
    <RadioGroupField
      {...rest}
      disabled={disabled || groupLoading}
      options={options}
    />
  );
};

HostField.propTypes = {
  disabled: PropTypes.bool,
  user: PropTypes.object,
  group: PropTypes.object,
};

export default HostField;
